declare global {
    interface Window {
        dataLayer: any[]
    }
}

window.dataLayer = window.dataLayer || []

export default defineNuxtPlugin((nuxtApp) => {
    let lastPageViewPath = ''

    function sendPageView(route: any = nuxtApp.$router.currentRoute.value, head: any = { title: '' }) {
        window.dataLayer.push({
            event: 'pageview',
            page: {
                path: route.fullPath,
                title: head.title || document.title,
            },
        })
    }

    function sendGTMEvent(payload: any) {
        if (payload) {
            if (!payload.eventValue) {
                payload.eventValue = 0
            }
            try {
                window.dataLayer.push(payload)
            } catch (error) {
                console.warn('[GTM]', error)
            }
        }
    }

    // Track route changes
    nuxtApp.$router.afterEach((to: any, from: any) => {
        if (lastPageViewPath === to.fullPath || !from.name) {
            return
        }

        const shouldSendPageView = to.fullPath.replace(/#.*$/i, '') !== from.fullPath.replace(/#.*$/i, '')

        if (shouldSendPageView) {
            sendPageView(to, {})
        }

        lastPageViewPath = to.fullPath
    })

    return {
        provide: {
            gtm: {
                execute(...args: any[]) {
                    window.dataLayer.push(...args)
                },
                sendPageView,
                sendGTMEvent,
            },
        },
    }
})


